import axios from 'axios'
import { format } from 'date-fns'
import { getUA } from 'react-device-detect'

import { InstitutionDetail } from '@/types/institution'
import { getSession } from '@/utils/session'

interface LogData extends Pick<DiscordLog, 'message'> {
  errorType: 'error_response_api' | 'unexpected_error' | 'error_page'
  description: string
  payload?: Record<string, any>
}

export const log = ({ message, payload, errorType, description }: LogData) => {
  const user = getSession('b-bfb') as InstitutionDetail | null
  const url = process.env.REACT_APP_BFB_LOG_URL

  const data: DiscordLog = {
    key: `${errorType}_${user?.investor_id ?? ''}_${format(new Date(), "yyyy-MM-dd'T'HH:mm")}`,
    type: 'error',
    message,
    data: {
      errorType,
      description,
      timestamp: new Date().toISOString(),
      deviceType: 'Browser',
      userAgent: getUA,
      appVersion: '',
      userId: String(user?.investor_id ?? ''),
      email: user?.email ?? '',
      handphone: '',
      additionalInfo: {
        pageUrl: window.location.href,
        ...payload
      }
    }
  }

  axios({
    method: 'post',
    url,
    data
  })
    .then(({ data: responseData }) => {
      console.log(responseData)
    })
    .catch((error) => {
      console.error(error)
    })
}
